import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, delay } from 'rxjs/operators';
import { WsArticulo, IWsArticulo } from '../classes/ws-articulo';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WsArticuloService {
  endpoint = `/api`;

  constructor(private http: HttpClient) { }

  get(solucion: string, aplicacion: string): Observable<WsArticulo[]> {
    // const options = { headers: { context: ctx || '' } };
    return this.http.get<IWsArticulo[]>(`${this.endpoint}/wsArticulo/${solucion}/${aplicacion}`)
      .pipe(
        // delay(1000),
        map((res: IWsArticulo[]) => res.map(item => new WsArticulo(item)))
      );
  }

  getByID(IdArticulo: number): Observable<WsArticulo> {
    return this.http.get<IWsArticulo>(`${this.endpoint}/wsArticulo/${IdArticulo}`)
      .pipe(
        map((res: IWsArticulo) => new WsArticulo(res))
      );
  }

  insert(wsArticulo: WsArticulo, ctx?): Observable<number> {
    const ws = { ...wsArticulo };
    if (ws.Especificaciones && typeof ws.Especificaciones === 'object') {
      ws.Especificaciones = JSON.stringify(ws.Especificaciones);
    }

    return this.http.post<number>(`${this.endpoint}/wsArticulo`, ws, { headers: { context: ctx || 'body' } });
  }

  delete(wsArticulo: WsArticulo): Observable<boolean> {
    return this.http.delete<boolean>(`${this.endpoint}/wsArticulo/${wsArticulo.IdArticulo}`, { headers: { context: 'body' } });
  }

}
